import { Box, Step, StepLabel, Stepper } from "@mui/material";

interface StepsProps {
  activeStep: number;
  steps: string[];
}

export const Steps = ({ activeStep, steps }: StepsProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step
            key={label}
            sx={{
              "& .MuiStepLabel-root .Mui-completed": {
                color: "secondary.dark", // circle color (COMPLETED)
              },
              "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                {
                  color: "grey.500", // Just text label (COMPLETED)
                },
              "& .MuiStepLabel-root .Mui-active": {
                color: "secondary.main", // circle color (ACTIVE)
              },
              "& .MuiStepLabel-root .MuiStepIcon-text": {
                fill: "#fff", // circle's number (ACTIVE)
              },
            }}
          >
            <StepLabel sx={{ color: "#fff" }}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
